
import { defineComponent, PropType } from 'vue';
import { Position } from '@/views/interfaces/entities.ts';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'tournament-position',
  props: {
    disable: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    rowspan: {
      type: String,
      default: '1',
    },
    position: {
      type: Object as PropType<Position>,
      required: true,
      default: () => ({
        posIndex: -1,
        player:{
          name: '',
          avatar: 'https://vignette.wikia.nocookie.net/universe-of-smash-bros-lawl/images/4/48/SSB4_random_icon.png',
        },

      })
    },
  },
  computed:{
    ...mapGetters({
      selectedPosIndexes: 'tournament/getMatchPosIndexes',
      tournament: 'tournament/getTournament',
    }),
  },
  data() {
    return {
      avatar:
        'https://vignette.wikia.nocookie.net/universe-of-smash-bros-lawl/images/4/48/SSB4_random_icon.png',
    };
  },

  methods: {
    ...mapActions({
      selectMatch: 'tournament/selectMatch',
    }),

    select(){
      if(this.tournament.status === 'demo') return;
      this.selectMatch(this.position.nextPos);
    }
  },
});
